import React from 'react'
import { observer } from 'mobx-react'
import scrollToTop from 'decorators/scrollToTop'
import FileButton from 'components/FileButton'
import ProgressSpinner from 'components/ProgressSpinner'
import Icon from 'components/Icon'
import { FlexContainer, FlexItem } from 'components/Flex'
import Document from 'components/Document'
import './styles.sass'

@scrollToTop
@observer
export default class UploadDocumentsStep extends React.Component {
  render () {
    const { step } = this.props
    return (
      <div className="upload-documents-step">
        <div className="container">
          <div className="columns is-mobile">
            <div className="column">
              <div className="has-text-centered">
                <UploadButton onChange={(files) => step.addFiles(files)} />
              </div>

              {step.documents.length === 0
                ? step.loading
                  ? <Loading />
                  : <NoDocuments />
                : (
                  <FlexContainer className="documents has-spacing-top" direction="column">
                    {step.documents.map((d) =>
                      <FlexItem key={d.cid} className="document-wrapper">
                        <Document
                          document={d}
                        />
                      </FlexItem>
                    )}
                  </FlexContainer>
                )
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const UploadButton = ({ onChange }) => (
  <FileButton onChange={onChange} multiple>
    <button className="upload-button">
      <Icon material name="cloud upload" large />
    </button>
  </FileButton>
)

const Loading = () => (
  <FlexContainer className="has-spacing-top" direction="column">
    <FlexItem>
      <ProgressSpinner blue />
    </FlexItem>
  </FlexContainer>
)

const NoDocuments = () => (
  <div className="no-documents">
    <div className="content">
      <p>
        Upload any relevant documents
      </p>
      <p className="example">
        (i.e. W-2s, 1099s, last year's return)
      </p>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/UploadDocuments/index.jsx